import { NotificationDetail } from '@centecomm/portal-service';
import { useNotification } from '@centecomm/portal-service-react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { EditorContentDisplay } from 'Shared/Content';
import { LoadingContent } from 'Shared/PageElements';
import { Notifications as NotificationsState } from 'State';
import { useTranslation } from 'react-i18next';
import DynamicTranslatedContent from 'Core/i18n/Components/DynamicTranslatedContent';
import styles from './notifications-details.module.css';

interface NotificationDetailsProps {
    notificationId: number;
    removeNotification: (notificationId: number) => void;
}

function NotificationDetails({
    notificationId,
    removeNotification,
}: NotificationDetailsProps): React.ReactElement<NotificationDetailsProps> {
    const dispatch = useDispatch();

    const { t } = useTranslation('notificationsFeature');

    const [notificationLoaded, setNotificationLoaded] = React.useState<boolean>(false);
    const [notification, setNotification] = React.useState<NotificationDetail>();

    const { deleteNotification, getNotificationDetails } = useNotification();

    React.useEffect(() => {
        getNotificationDetails(notificationId).then((notificationDetail: NotificationDetail) => {
            setNotification(notificationDetail);
            setNotificationLoaded(true);

            deleteNotification(notificationId).then(() => {
                removeNotification(notificationId);

                dispatch({
                    type: NotificationsState.Actions.DECREASE_COUNT,
                    payload: 1,
                });
            });
        });
    }, []);

    if (!notificationLoaded) return <LoadingContent message={t('notificationDetails.loading')} />;

    return (
        <div className={`${styles.NotificationDetails} ${styles.ScrollWrapper}`}>
            <DynamicTranslatedContent
                content={notification?.subject || ''}
                showLoadingState
                extendedOptions={{
                    bypassMainAppLanguage: true,
                }}
            >
                {({ translatedContent }) => <h2>{translatedContent}</h2>}
            </DynamicTranslatedContent>
            <div>
                <DynamicTranslatedContent
                    content={notification?.description || ''}
                    showLoadingState
                    extendedOptions={{
                        bypassMainAppLanguage: true,
                    }}
                >
                    {({ translatedContent }) => <EditorContentDisplay content={translatedContent} />}
                </DynamicTranslatedContent>
            </div>
        </div>
    );
}

export default NotificationDetails;
